







































































import { IRequisition, RequisitionFieldError } from '@/models';
import { ErrorManager } from '@/models/error';
import Vue from 'vue';
import { mapActions } from 'vuex';
import ConfirmationDialog from '../common/ConfirmationDialog.vue';

export default Vue.extend({
  components: { ConfirmationDialog },
  name: 'RequisitionPONumberMenu',

  props: {
    requisition: {
      type: Object as () => IRequisition,
      required: true
    },
    disabled: Boolean
  },

  data() {
    return {
      poNumberLoading: false,
      poNumberDialog: false,
      errorMessage: '',

      po_number: '',
      fieldError: new RequisitionFieldError()
    };
  },

  watch: {
    poNumberDialog(value: boolean) {
      if (value) {
        if (this.requisition.po_number) {
          // assign the current po_number to requisition po_number
          this.po_number = this.requisition.po_number;
        }
      }
    }
  },

  methods: {
    ...mapActions({
      assignRequisitionPONumber: 'requisition/assignRequisitionPONumber'
    }),

    clearErrors() {
      this.errorMessage = '';
      this.fieldError = new RequisitionFieldError();
    },

    closeDialog() {
      this.clearErrors();
      this.errorMessage = '';
      this.poNumberLoading = false;
      this.poNumberDialog = false;
    },

    setRequisitionPONumber(po_number: string) {
      this.poNumberLoading = true;
      this.assignRequisitionPONumber({
        requisitionId: this.requisition.id,
        po_number
      })
        .then(() => {
          this.closeDialog();
        })
        .catch(error => {
          if (error.response) {
            // client received an error response that falls out of range 2xx
            if (
              RequisitionFieldError.isRequisitionFieldError(error.response.data)
            ) {
              this.fieldError = new RequisitionFieldError(error.response.data);
            }
          }

          // Seperate check as the intent is not the same as the field error
          if (error.response) {
            if (error.response.data.detail) {
              this.errorMessage = error.response.data.detail;
            } else {
              this.errorMessage = ErrorManager.extractApiError(error);
            }
          }
        })
        .finally(() => {
          this.poNumberLoading = false;
        });
    }
  }
});
